import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/styles/sass/global.scss";
import i18n from "./system/lang/lang.js";
import { createPinia } from "pinia";
import VueQRCodeComponent from 'vue-qrcode-component';
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import {
  balanceLog,
  getMemberInfo,
  // platformAll,
  getMTGames,
  getGameBalance,
  gameWithdraw,
  announcement,
  platformList,
  platformAll,
} from "@/system/request/api/api";
import { handleError } from "@/system/request/handleRes";
import VueMarqueeSlider from 'vue-marquee-slider';
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify);
Vue.use(VueGoodTablePlugin);
Vue.use(VueMarqueeSlider);
Vue.component('qr-code', VueQRCodeComponent);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(createPinia())

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();

new Vue({
  data() {
    return {
      isLoading: false,
      userInfo: {
        invest: 0,
        nickname: '',
        check_kyc: {

        },
        rank: {
          rank_name_en: ''
        }
      },
      currentAddress: '',
      page: 1,
      teamList: [],
      newsList: [],
      gameList: [],
      mtGameList: [],
      category: '',
      gameAmount: [],
      packageList: [],
      rewardList: [],
      promotionList: [],
      newsItem: {},
      assetInfo: {
        static_bonus: 0,
        special_bonus: 0,
        dynamic_bonus: 0,
        level_bonus: 0,
      },
      country_code: '',
      countryOptions: [],
      variant: 'success',
      modal: {
        title: "",
        msg: "",
        action: false,
        error: false,
      },
      inv_link: '',
      bankInfo: {},
      agentCode: 'guest',
      globalSetting: {},
      tabs: [],
      latestLog: null,
      firstTime: true,
      finalNum: 0,
      customTimer: null,
      deviceID: 0,
      sidebarShown: false,
    }
  },
  watch: {
    async 'latestLog.id'() {
      if (this.firstTime) {
        this.firstTime = false;
      } else if (this.latestLog != null) {
        this.finalNum = await parseFloat(this.latestLog.amount);
      }
    }
  },
  methods: {
    parseFloatCustom(num) {
      if (num) {
        if (num.toString().includes(" ")) {
          num = Number(num.replace(/\s+/g, ""));
        }
      }
      const factor = Math.pow(10, 3);


      return parseFloat(Math.trunc(num * factor) / factor).toLocaleString(undefined, {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })
    },
    changeLan(lan) {
      localStorage.setItem('lan', lan);
      this.$i18n.locale = lan;
    },
    copy(value) {
      navigator.clipboard.writeText(value)
        .then(() => {
          alert(`${this.$t('copySuccess')}: ` + value);
        })
        .catch((error) => {
          alert(error);
        });
    },
    getMTGame() {
      var self = this;
      self.$root.isLoading = true;
      var result = getMTGames(22);
      result
        .then(function (value) {
          self.mtGameList = value.data.data;
          self.$root.isLoading = false;
        });
    },
    getGame() {
      var result;
      var token = localStorage.getItem('gamingToken') ?? '';
      if (token.length <= 0) {
        result = platformAll(this.category);
      } else {
        result = platformList(this.category);

      }
      var self = this;
      // self.isLoading = true;
      result
        .then(function (value) {
          self.tabs = [];
          var gameList = value.data.data;
          gameList.forEach(element => {
            // element['flipped'] = false;
            if (element.id != 22 && element.id != 23)
              self.tabs.push(element)
          });
          // self.tabs = gameList;
          self.isLoading = false;
        })
    },

    announcement() {
      var self = this;
      self.$root.isLoading = true;
      var result = announcement(3);
      result
        .then(async function (value) {
          self.$root.isLoading = false;
          // window.location.href = link;
          console.log(value.data);
        })
        .catch(function (error) {
          self.$root.isLoading = false;
          self.$root.makeToast("warning", self.$t(error.response.data.message), '');
        });

    },

    checkJson(title) {
      var str = title;
      var processed = '';

      try {
        const parsed = JSON.parse(str);

        if (typeof parsed === "string")
          processed = title;
        else
          processed = parsed[this.$i18n.locale];

      } catch (e) {
        processed = title;
      }

      return processed;
    },

    getInfo() {
      var token = localStorage.getItem('gamingToken') ?? '';
      if (token.length <= 0) {
        return;
      }
      var self = this;
      self.isLoading = true;
      var result = getMemberInfo();
      result
        .then(function (value) {
          if (value.data.code == '200') {
            self.userInfo = value.data.data;
            if (self.userInfo.nickname == null) self.userInfo.nickname = '';
          self.isLoading = false;
            self.getGameInfo();
            // self.getMTGame();
          } else {
            self.makeToast("danger", self.$t(value.data.message), '');

          }
        })
        .catch(function (error) {
          self.isLoading = false;
          if (error.response.status == 403) {
            localStorage.removeItem('gamingToken');

          } else
            self.makeToast("warning", self.$t(handleError(error)), '');
        });
    },

    async getGameInfo() {
      var gameID = await localStorage.getItem('currentGame');
      if (gameID) {
        var self = this;
        self.isLoading = true;
        var result = getGameBalance(gameID);
        result
          .then(async function (value) {
            self.isLoading = false;
            var selectedGameBalance = await value.data.data.balance;
            if (parseFloat(selectedGameBalance) > 1) {
              self.gameWithdraw(gameID);
            } else {
              localStorage.removeItem('currentGame');
            }
          self.isLoading = false;

          })
          .catch(function (error) {
            self.isLoading = false;
            self.makeToast("warning", self.$t(error.response.data.message), '');
          });
      }

    },
    gameWithdraw(gameID) {
      var self = this;
      // self.isLoading = true;
      let formData = new FormData();
      var result = gameWithdraw(gameID, formData);
      result
        .then(function (value) {
          self.isLoading = false;
          if (value.data.code == '200') {
            self.getInfo();
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          // self.getInfo();
          self.isLoading = false;
          console.error(error);
          // self.makeToast("warning", self.$t(error.response.data.message), '');
        });
    },

    getBalanceLog() {
      var self = this;
      // self.isLoading = true;
      var result = balanceLog();
      result
        .then(function (value) {
          // self.isLoading = false;
          if (value.data.code == '200') {
            var log = value.data.data.list;
            self.latestLog = log[0];
          } else {
            self.makeToast("danger", self.$t(value.data.message), '');

          }
        })
        .catch(function (error) {
          clearInterval(self.customTimer);
          self.customTimer = null;
          if (error.response.status == 403) {
            localStorage.removeItem('gamingToken');

          } else
            self.makeToast("warning", self.$t(handleError(error)), '');
        });
    },


    makeToast(type, title, msg) {
      this.variant = type;
      this.modal.title = title;
      this.modal.msg = msg;
      if (type == 'info') {
        this.modal.action = true;
      } else {
        this.modal.action = false;

      }
      console.log('abc');
      this.$bvModal.show('modal-errorMsg');
      // });
    },
    checkKYC() {
      if (this.userInfo.check_kyc.can_withdraw == 'approved') {
        this.$bvModal.show('withdraw');

      } else {
        this.modal = {
          title: this.$t('kyc'),
          msg: this.$t('kyc_hint'),
          action: false,
          error: true,
        };
        this.$bvModal.show('modal-errorMsg');

      }
    },
    clearErrorMsg() {
      this.$root.modal = {
        title: "",
        msg: "",
        action: false,
        error: false,
      };
      console.log(this.modal);

    },
    closeAllModals() {
      console.log('check');
      this.$emit('close-all-modals')
      this.$emit('bv::hide::modal', null); // Closes all modals
      // Or use this.$root.$emit('bv::hide::modal', '*') for the same effect
    },

  },
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
